import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useMutation } from 'hooks/graphql/useMutation';
import { useMonetaryAmount } from 'hooks/useMonetaryAmount';

import type {
  UpdateExternalEthDeposit,
  UpdateExternalEthDepositVariables,
} from './__generated__/useUpdateExternalEthDeposit.graphql';

const UPDATE_EXTERNAL_DEPOSIT_MUTATION = gql`
  mutation UpdateExternalEthDeposit($input: updateExternalEthDepositInput!) {
    updateExternalEthDeposit(input: $input) {
      currentUser {
        slug
        pendingDeposits {
          id
          amounts {
            ...useMonetaryAmount_monetaryAmount
          }
          date
          providerType
          transactionHash
        }
      }
      errors {
        code
        message
      }
    }
  }
  ${useMonetaryAmount.fragments.monetaryAmount}
` as TypedDocumentNode<
  UpdateExternalEthDeposit,
  UpdateExternalEthDepositVariables
>;

export const useUpdateExternalEthDeposit = () => {
  return useMutation<
    UpdateExternalEthDeposit,
    UpdateExternalEthDepositVariables
  >(UPDATE_EXTERNAL_DEPOSIT_MUTATION, {
    showErrorsWithSnackNotification: true,
  });
};
